exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field__notice[data-v-833fa65a]{flex:none;display:inline-flex;align-items:center;margin-left:5px;overflow:visible;cursor:help;outline:none}.field__notice svg[data-v-833fa65a]{width:13px;height:13px;display:block}.field__tooltip[data-v-833fa65a]{position:fixed;z-index:100;max-width:260px;padding:8px 10px;transform:translateX(-50%);font-size:12px;font-weight:400;line-height:1.5;text-align:left;color:#fff;background-color:#333;border-radius:4px;box-shadow:0 2px 6px rgba(0,0,0,.2);overflow:visible;text-overflow:clip;white-space:normal;pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-833fa65a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contents/shared/FieldNotice.vue
// module id = 294
// module chunks = 0